export default __webpack_public_path__ + "f76b5d3.png";